<ins-modal2 id="subscription-info-modal" [size]="'small'" [showXButton]="false">
  <ins-modal-body2 [noPadding]="true">
    <div class="about-dialog">
      <div class="xs-car-logo">
        <div *ngIf="old" class="xs-car-bg"><img src="/sotixsight/get-resource/assets/images/xs-car-bg.png" /></div>
        <div *ngIf="old" class="xs-car-fg"><img src="/sotixsight/get-resource/assets/images/xs-car.png" /></div>
        <div *ngIf="hidden" class="xs-car-new">
          <img src="/sotixsight/get-resource/assets/images/SotiXsightRaceCar.png" />
        </div>
        <div type="button" class="forward" (click)="imageSource()"></div>
        <div type="button" class="back" (click)="prevSource()"></div>

        <div class="xs-car-banner">
          <div class="xs-car-banner-text">{{ getAppVersionString() }}</div>
         <img class="xs-car-banner-logo" src="{{ 'SOTI-XSight-Horizontal.svg' | xsImage }}">
        </div>
      </div>

      <div class="about-modal-body">
        <div class="about-license-message">{{ getLicenseMessage() }}</div>
        <span class="about-progress-bar">
          <xs-license-info [licenseUpdated$]="licenseUpdated$"></xs-license-info>
        </span>
      </div>
      <div class="about-modal-footer">
        <div class="btn-group">

          <button class="xs-btn btn-outline" type="button" 
            *ngIf="isRefreshLicenseButtonAvaliable()"
            [soti-tooltip]="'about_UpdateLicense_Button' | xsI18n"
            placement="top" (click)="refreshLicense()">
            <span>{{ 'about_UpdateLicense_Button' | xsI18n }}</span>
          </button>

          <button class="xs-btn btn-outline btn-extend" type="button" 
            [soti-tooltip]="'licenceExpiration_Action_Button' | xsI18n"
            placement="top" (click)="licenseAction()">
            <span>{{ 'licenceExpiration_Action_Button' | xsI18n }}</span>
          </button>

          <button class="xs-btn btn-outline btn-close" type="button" (click)="close()">
            <span>{{ 'about_Close_Button' | xsI18n }}</span>
          </button>
        </div>
        <div class="patent-container">
          <div class="bottom-patent">
            {{ 'about_Patent_Caption' | xsI18n }}&nbsp;<span class="patent-pending">{{ 'about_Patent_Caption_2' | xsI18n }}</span>
         </div>
         <a href="/sotixsight/get-resource/license.html" target="_blank" class="license-agr nav-link normal">
          {{ 'about_LicenceAgreement_Caption' | xsI18n }}
        </a>
        </div>

        <div class="caption-group">
          <div class="bottom-padding-default">
            {{ 'about_Copyright_Caption' | xsI18n : copyrightYear }}
          </div>
        </div>
      </div>
    </div>
  </ins-modal-body2>
</ins-modal2>
